<div class="selenium-leave-class-modal">
    <div class="modal-header px-0 py-0">
        <h5 class="modal-title selenium-leave-class-modal-title">Confirmation Required</h5>
        <button
            (click)="activeModal.dismiss('Cross click')"
            aria-label="Close"
            class="btn-close selenium-leave-class-modal-x-button"
            data-dismiss="modal"
            type="button"
        ></button>
    </div>
    <div class="modal-body">
        <div
            class="modal-body p-0 rosterModal__body modal-body-text selenium-leave-class-modal-body-description"
        >
            <p>
                Are you sure you want to leave: <br />
                <strong>{{ classDetails }}</strong
                >?
            </p>
            <p>
                This class will be removed from your list, and all assignments for this class will
                no longer be available.
            </p>
        </div>
    </div>
    <div class="modal-footer px-0 pb-0 pt-1">
        <button
            (click)="activeModal.dismiss('Cross click')"
            class="btn btn-outline-secondary selenium-join-class-modal-cancel-leaving-button"
            type="button"
        >
            OK
        </button>
        <input
            (click)="leaveClass(); activeModal.dismiss('Cross click')"
            class="btn btn-outline-primary selenium-leave-class-delete-button"
            data-dismiss="modal"
            type="submit"
            value="Delete"
        />
    </div>
</div>
